import TableStampCollection from '../../components/table/companies/TableStampCollection'

const StampCollecton = () => {
  return <TableStampCollection />
}

export default StampCollecton
